<template>
  <el-dialog
    width="440px"
    :visible.sync="$_visible"
    @open="onOpenDialog"
    @close="closeDialog">
    <p slot="title" class="text_size_16 text_color_white text_weight_bold">重命名</p>
    <el-form
      class="form padding-left-20 padding-right-20"
      ref="form"
      :model="form"
      :rules="rules"
      @submit.native.prevent
      size="small"
      label-position="left"
      label-width="0px"
      hide-required-asterisk>
      <el-form-item prop="newName">
        <el-input type="text" v-model="form.newName" placeholder="请输入分组名称"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button size="small" @click="closeDialog">取消</el-button>
      <el-button type="primary" :loading="saveBtnLoading" size="small" @click="saveForm">确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import * as api from '~/api'
export default {
  data () {
    return {
      // 确定按钮loading
      saveBtnLoading: false,
      // 表单对象
      form: {
        newName: ''
      },
      // 添加目标表达那对象验证
      rules: {
        newName: [
          { required: true, message: '请输入分组名', trigger: 'blur' }
        ]
      }
    }
  },
  props: {
    // 父组件传来的控制
    visible: {
      type: Boolean,
      default: false
    },
    // 分组id
    groupId: {
      type: String,
      default: ''
    },
    // 旧名称
    oldName: {
      type: String,
      default: ''
    }
  },
  computed: {
    $_visible: {
      get () {
        return this.visible
      },
      set (newValue) {
        this.$emit('update:visible', newValue)
      }
    },
    // 项目id
    projectId () {
      return this.$route.query.projectId || ''
    }
  },
  methods: {
    // 重命名
    editChartGroup (result) {
      this.saveBtnLoading = true
      api.editChartGroup({
        spaceId: this.projectId,
        chartGroupId: this.groupId,
        ...this.form
      }).then(res => {
        if (res.data.code === 0) {
          // console.log('重命名', res.data.data)
          this.$message.success('重命名成功')

          this.$emit('callback')
          this.closeDialog()
        } else {
          this.$message.error(res.data.message)
        }
        this.saveBtnLoading = false
      }).catch(err => {
        this.saveBtnLoading = false
        console.log(err)
        this.$message.error('网络错误，请重试！')
      })
    },

    // 保存提交
    saveForm () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 重命名
          this.editChartGroup()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    // 关闭添加表单的dialog
    closeDialog () {
      this.$refs.form.resetFields()
      this.$_visible = false
    },

    // dialog 打开的时候触发
    onOpenDialog () {
      this.form.newName = this.oldName
    }
  }
}
</script>
<style lang="scss" scoped>

</style>
